import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
// CSP の font-src 'self' で Google Fonts を読めないので、Noto Sans JP は同梱する
// （unicode-range で分割されていて、使う文字の分だけ読み込まれる）
import "@fontsource/noto-sans-jp/400.css";
import "@fontsource/noto-sans-jp/500.css";
import "@fontsource/noto-sans-jp/700.css";
import "./index.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("#root が見つかりません");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
